import React from 'react';
import { Table, Empty, Input } from 'antd';
import { PhoneOutlined, ClockCircleOutlined, CheckCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import TableSkeleton from '../../../components/@shared/TableSkeleton';
import { StatCard } from '../../../components/overview_page';
import { colors } from '../../../../domain/types/colors';
import useReceptionistAiListPageController from '../controllers/useReceptionistAiListPageController';
import { getReceptionistAiColumns } from '../receptionistAiListPage.columns';
import { RECEPTIONIST_AI_PAGE_PATH } from '../ReceptionistAiListPage';

const ReceptionistSettingsTab: React.FC = () => {
  const { state, actions } = useReceptionistAiListPageController();
  const { rows, totalRows, totals, isLoading, isTotalsLoading, searchValue, currentPage, pageSize } = state;
  const { setSearchValue, setCurrentPage, setPageSize } = actions;
  const navigate = useNavigate();

  const columns = getReceptionistAiColumns();

  return (
    <>
      <div className="receptionist-ai-page__stats-row">
        <StatCard
          icon={<PhoneOutlined style={{ fontSize: 24, color: colors.primary.main }} />}
          label="APPELS CAPTÉS"
          value={String(totals.callsCount)}
          subtitle="ce mois-ci"
          iconBgColor="green"
          loading={isTotalsLoading}
        />
        <StatCard
          icon={<ClockCircleOutlined style={{ fontSize: 24, color: colors.primary.main }} />}
          label="DURÉE TOTALE"
          value={`${Math.round(totals.callDurationMinutes)} min`}
          subtitle="ce mois-ci"
          iconBgColor="blue"
          loading={isTotalsLoading}
        />
        <StatCard
          icon={<CheckCircleOutlined style={{ fontSize: 24, color: colors.primary.main }} />}
          label="OPPORTUNITÉS DÉTECTÉES"
          value={String(totals.opportunitiesCount)}
          subtitle="ce mois-ci"
          iconBgColor="green"
          loading={isTotalsLoading}
        />
      </div>

      <Input
        className="receptionist-ai-page__search"
        prefix={<SearchOutlined />}
        placeholder="Utilisateur"
        allowClear
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
      />

      <div className="receptionist-ai-page__table">
        {isLoading ? (
          <TableSkeleton columns={columns} rows={pageSize} />
        ) : rows.length === 0 && !searchValue ? (
          <Empty description="Aucun utilisateur avec un réceptionniste IA" className="receptionist-ai-page__empty" />
        ) : (
          <Table
            columns={columns}
            dataSource={rows}
            rowKey="subscription_id"
            pagination={{
              current: currentPage,
              total: totalRows,
              pageSize: pageSize,
              onChange: setCurrentPage,
              onShowSizeChange: (current, newPageSize) => setPageSize(newPageSize),
              pageSizeOptions: [10, 20, 50, 100],
              showSizeChanger: true,
            }}
            rowClassName="table-row"
            onRow={(record) => ({
              onClick: () => navigate(`${RECEPTIONIST_AI_PAGE_PATH}/${record.subscription_id}`),
              style: { cursor: 'pointer' },
            })}
          />
        )}
      </div>
    </>
  );
};

export default ReceptionistSettingsTab;
